import React from 'react';
import Alert from '@material-ui/lab/Alert';
import {makeStyles} from '@material-ui/core/styles';
import {useNotification} from "./NotificationProvider";

const useStyles = makeStyles(theme => ({
    root: {
        position: "fixed",
        top: '5rem',
        right: 0,
        margin: '1rem',
        boxSizing: 'border-box',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
        zIndex: 300
    },
    notification: {
        animation: `$slideUp 800ms ${theme.transitions.easing.easeOut}`,
        '@global': {
            '@keyframes slideUp': {
                '0%': {
                    transform: 'translateY(50%)',
                    opacity: 0
                },
                '100%': {
                    transform: 'translateY(0W)',
                    opacity: 1
                }
            }
        }
    }
}));


const Notifications = () => {
    const classes = useStyles();
    const {removeNotification, notifications} = useNotification();
    return (
        <div className={classes.root}>
            {
                notifications.map((n: any) => {
                    return <Alert style={{ whiteSpace: 'pre-line' }}
                        key={n.id.toString()}
                        className={classes.notification}
                        onClose={() => removeNotification(n.id)}
                        severity={n.severity}>
                        {n.message}
                    </Alert>
                })
            }
        </div>
    );
};


export {Notifications};
